import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { XCircle, Home, ArrowLeft } from 'lucide-react';

export default function PaymentCancel() {
    const { user } = useAuth();
    const dashboardTo = user?.role === 'provider' ? '/provider' : '/client';
    return (
        <div className="min-h-screen flex items-center justify-center p-6" style={{ background: 'var(--bg)' }}>
            <div className="max-w-lg w-full border-2 p-8 text-center"
                style={{ borderColor: 'var(--border)', background: 'var(--card-bg)' }}
                data-testid="payment-cancel-page">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center"
                    style={{ background: 'rgba(107,114,128,0.12)' }}>
                    <XCircle className="w-10 h-10" style={{ color: '#6B7280' }} />
                </div>
                <h1 className="font-display font-black text-2xl mb-2">Pago cancelado</h1>
                <p className="text-sm opacity-70 mb-6">
                    No se realizó ningún cargo. Puedes volver al panel e intentar el pago nuevamente cuando quieras.
                </p>
                <Link to={dashboardTo}
                    className="inline-flex items-center gap-2 text-white px-6 py-3 font-bold text-sm"
                    style={{ background: '#7C6BEF' }}>
                    <ArrowLeft className="w-4 h-4" /> Volver al panel
                </Link>
            </div>
        </div>
    );
}
